// Utility functions for API handling

export const handleApiError = (error) => {
  console.error('API Error:', error);
  
  if (error.message.includes('Failed to fetch')) {
    return 'Network error. Please check your internet connection.';
  }
  
  if (error.message.includes('401')) {
    return 'Authentication failed. Please check your API key.';
  }
  
  if (error.message.includes('404')) {
    return 'API endpoint not found.';
  }
  
  if (error.message.includes('500')) {
    return 'Server error. Please try again later.';
  }
  
  return error.message || 'An unexpected error occurred.';
};

export const validateApiResponse = (response) => {
  if (!response) {
    throw new Error('No response received from server');
  }
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return response;
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isValidPhone = (phone) => {
  const phoneRegex = /^\+?[\d\s\-()]+$/;
  return phoneRegex.test(phone) && phone.length >= 10;
};

export const formatMemberData = (member) => {
  return {
    ...member,
    id: member.id || member._id,
    skills: Array.isArray(member.skills) ? member.skills : [],
    joinDate: member.joinDate ? member.joinDate.split('T')[0] : new Date().toISOString().split('T')[0],
    // Only use initials as fallback if no image URL is provided
    image: member.image || (member.name ? member.name.split(' ').map(n => n[0]).join('').toUpperCase() : ''),
    linkedin: member.linkedin ? member.linkedin.replace(/^https?:\/\//, '') : '',
    github: member.github ? member.github.replace(/^https?:\/\//, '') : ''
  };
};
